import classNames from 'classnames';
import { MouseEventHandler, useCallback } from 'react';
import { Outlet, useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { Layout } from 'tdesign-react';

import { Add3 } from '@/components/icon';
import { UGC_BOOK_LIST } from '@/config/menu';
import { AuthGrid } from '@/pages/auth/authGrid';
import { AuthIDEnum } from '@/pages/auth/authID';
import { EDITOR, UGC_BOT_LIST, UGC_STORY_LIST } from '@/router/const';
import { isWoa } from '@/utils/getApiDomain';

import styles from './index.module.less';

const { Content } = Layout;

const BookListLayout = () => {
  const { pathname } = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  const handleClick1: MouseEventHandler<HTMLDivElement> = useCallback((e) => {
    const { key } = e.currentTarget.dataset;
    if (key) {
      navigate(key);
    }
  }, []);

  const handleClick2 = useCallback(() => {
    if (pathname === UGC_STORY_LIST) {
      navigate(EDITOR);
    } else if (pathname === UGC_BOT_LIST) {
      searchParams.set('mode', 'add');
      setSearchParams(searchParams);
    }
  }, [pathname, searchParams]);

  return (
    <AuthGrid id={AuthIDEnum.LIST}>
      <div className={classNames('nova-ugc-list-root', styles.listWrapper)}>
        <Layout className="nova-list-layout">
          <div className="nova-ugc-list-menu">
            <div className={styles.tabs}>
              {UGC_BOOK_LIST.map((item, index) => (
                <div className={classNames({ [styles.tab]: 1, [styles['tab-active']]: pathname === item.path })}
                  key={index}
                  data-key={item.path}
                  onClick={handleClick1}
                >
                  <div className={styles.icon}>{item.svg}</div>
                  <div className={styles.text}>
                    {item.label}
                  </div>
                </div>
              ))}
            </div>
            {!isWoa && <div className={styles.operation} onClick={handleClick2}>
              <Add3 />
            </div>}
          </div>
          <Content className="nova-list-content">
            <Outlet />
          </Content>
        </Layout>
      </div>
    </AuthGrid>
  );
};

export default BookListLayout;
